module.exports = __webpack_public_path__ + "assets/img/two.4f1967d1.png";